<template>
  <div
    class="bg-surface-default-low rounded-md flex flex-col items-center gap-16 overflow-hidden px-12 py-16 md:mx-0 md:px-96"
  >
    <RevIllustration
      alt=""
      class="rounded-md overflow-hidden"
      :height="187"
      :src="imageUrl"
      :width="300"
    />

    <div>
      <div class="text-static-default-low body-1">
        {{
          i18n(translations.giftAmount, {
            price: i18n.price(price),
          })
        }}
      </div>
      <div
        v-if="displayExpirationDate && expiresAt"
        class="text-static-default-low body-1"
      >
        {{
          i18n(translations.validUntil, {
            expiresAt: i18n.date(new Date(expiresAt)),
          })
        }}
      </div>
    </div>

    <RevButton variant="secondary" @click="copyToClipboard">
      <div class="flex justify-between gap-32">
        <div>{{ promoToken }}</div>
        <IconCopy />
      </div>
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { IconCopy } from '@ds/icons/IconCopy'

import translations from './GiftCardsInformation.translations'

const i18n = useI18n()
const { openSuccessToast } = useTheToast()
const {
  market: { countryCode },
} = useMarketplace()
const props = defineProps<{
  price: Price
  imageUrl: string
  promoToken: string
  expiresAt: string | null
}>()

async function copyToClipboard() {
  navigator.clipboard.writeText(props.promoToken)
  openSuccessToast({ title: 'Copied' })
}

const displayExpirationDate = computed(() => {
  return countryCode !== MarketCountryCode.US
})
</script>
